import React from 'react';
import { Sidebar } from './Sidebar';
import { COLORS } from '../styles/theme';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div style={styles.container}>
      <Sidebar />
      <main style={styles.main}>
        {children}
      </main>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: COLORS.backgroundPrimary,
  },
  main: {
    flex: 1,
    marginLeft: 240,
    padding: 32,
    minHeight: '100vh',
    overflowY: 'auto' as const,
  },
};
